import { FilterType, Filter, FilterKey, EApplicantOfferPGKeys } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '..';

const key = FilterKey.COURSE;
export const getCourseFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter | null => {
  const filters = activeFilters[key] ?? [];
  let courseFilterOptions = filterOptions?.[EApplicantOfferPGKeys.COURSE_NAME];
  if (!courseFilterOptions) {
    console.warn('Course filter options could not be extracted from filter options.');
    courseFilterOptions = [];
  }

  const options = courseFilterOptions?.map(course => {
    return {
      label: course.label,
      value: course.value,
      checked: filters.some(filter => filter === course.value),
    };
  });

  return {
    name: 'Course',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: options,
    },
  };
};
